import {
  CompanyData,
  NotaryOnboarding,
  Profile,
  SelfProfile,
  StampWithImage,
} from '@et/typings';
import { AccountInfo } from '@azure/msal-browser';

export enum ProfileActionsType {
  SETP_ROFILE = '[SET_PROFILE] Set users profile',
  SET_AAD_USER_WITH_CLAIMS = '[SET_PROFILE] Set aad user with claims profile',
  SET_SELF_PROFILE = '[SET_PROFILE] Set self profile from /self',
  UPDATE_SELF_PROFILE = '[SET_PROFILE] Set self profile',
  GET_FULL_PROFILE = '[SET_PROFILE] get full profile from api',
  SET_FULL_PROFILE = '[SET_PROFILE] set full profile from api',
  UPDATE_FULL_PROFILE = '[UPDATE_PROFILE] update full profile',
  GET_COMPANY = '[SET_PROFILE] get company from api',
  SET_COMPANY = '[SET_PROFILE] set company from api',
  SET_NOTARY_STAMP = '[SET_PROFILE] Set notary stamps in store',
  SET_NOTARY_STAMP_AS_PRIMARY = '[SET_PROFILE] Set notary stamp in store as primary',
  SET_NOTARY_ONBOARDING = '[ONBOARDING] Set notary onboarding',
  CLEAR_NOTARY_ONBOARDING = '[ONBOARDING] Clear notary onboarding',
  SET_TWO_FACTOR_ENABLED = '[SET_PROFILE] Set Better Auth twoFactorEnabled from get-session',
}

export class SetAADUserWithClaims {
  static readonly type = ProfileActionsType.SET_AAD_USER_WITH_CLAIMS;
  constructor(public profile: Partial<AccountInfo>) {}
}

export class SetSelfProfile {
  static readonly type = ProfileActionsType.SET_SELF_PROFILE;
  constructor(public selfProfile: SelfProfile) {}
}

export class UpdateSelfProfile {
  static readonly type = ProfileActionsType.UPDATE_SELF_PROFILE;
  constructor(public selfProfile: Partial<SelfProfile>) {}
}

export class GetFullProfile {
  static readonly type = ProfileActionsType.GET_FULL_PROFILE;
  constructor(public profileId: string) {}
}
export class SetFullProfile {
  static readonly type = ProfileActionsType.SET_FULL_PROFILE;
  constructor(public profile: Profile) {}
}

export class UpdateFullProfile {
  static readonly type = ProfileActionsType.UPDATE_FULL_PROFILE;
  constructor(public profile: Partial<Profile>) {}
}

export class SetNotaryStamp {
  static readonly type = ProfileActionsType.SET_NOTARY_STAMP;
  constructor(public stamp: StampWithImage[]) {}
}

export class SetNotaryStampAsPrimary {
  static readonly type = ProfileActionsType.SET_NOTARY_STAMP_AS_PRIMARY;
  constructor(public stampId: string) {}
}

export class SetNotaryOnboarding {
  static readonly type = ProfileActionsType.SET_NOTARY_ONBOARDING;
  constructor(public payload: NotaryOnboarding) {}
}

export class ClearNotaryOnboarding {
  static readonly type = ProfileActionsType.CLEAR_NOTARY_ONBOARDING;
}

export class GetCompany {
  static readonly type = ProfileActionsType.GET_COMPANY;
  constructor(public companyId: string) {}
}

export class SetCompany {
  static readonly type = ProfileActionsType.SET_COMPANY;
  constructor(public company: CompanyData) {}
}

/**
 * Better Auth's own live `user.twoFactorEnabled` (from `GET /api/auth/get-session`) —
 * distinct from `SelfProfile.requiredMfaMethod`, which is Profile v2's policy of
 * whether the user *should* be enrolled. `mfaRequiredGuard` combines both to decide
 * whether to block the app behind the mandatory Authenticator-app enrollment gate.
 */
export class SetTwoFactorEnabled {
  static readonly type = ProfileActionsType.SET_TWO_FACTOR_ENABLED;
  constructor(public twoFactorEnabled: boolean) {}
}
